<template>
  <div class="bubble-box">

    <div class="text-with-pad">
      <span class="selectable-text invisible-space" :id="message.id" v-html="content" @click="onClicked"></span>
      
      <div v-if='preview' class="preview-quote" @click="onPreviewClicked" role="button" v-ripple>
        <span class="preview-q"></span>
        <div style="width:100%;">
          <v-layout row fill-height>
            <v-layout column>
              <div class="preview-title">{{title}}</div>
              <div class="preview-content">{{description}}</div>
            </v-layout>
            <div v-if="image != ''"
              class="preview" 
              :style="{ 'background-image': 'url(' + image + ')' }"
            ></div>
          </v-layout>
        </div>
      </div> 
    </div>

    <MessageState :state="message.sent ? message.state : null" :time="time"/>

  </div>
</template>

<script>
  import MessageState from './MessageState.vue'
  import { EventBus } from '@/event-bus'

  const urlify = "((?:(http|https|Http|Https|rtsp|Rtsp):\\/\\/(?:(?:[a-zA-Z0-9\\$\\-\\_\\.\\+\\!\\*\\'\\(\\)"
    + "\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,64}(?:\\:(?:[a-zA-Z0-9\\$\\-\\_"
    + "\\.\\+\\!\\*\\'\\(\\)\\,\\;\\?\\&\\=]|(?:\\%[a-fA-F0-9]{2})){1,25})?\\@)?)?"
    + "((?:(?:[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}\\.)+"   // named host
    + "(?:"   // plus top level domain
    + "(?:aero|arpa|asia|a[cdefgilmnoqrstuwxz])"
    + "|(?:biz|b[abdefghijmnorstvwyz])"
    + "|(?:cat|com|coop|c[acdfghiklmnoruvxyz])"
    + "|d[ejkmoz]"
    + "|(?:edu|e[cegrstu])"
    + "|f[ijkmor]"
    + "|(?:gov|g[abdefghilmnpqrstuwy])"
    + "|h[kmnrtu]"
    + "|(?:info|int|i[delmnoqrst])"
    + "|(?:jobs|j[emop])"
    + "|k[eghimnrwyz]"
    + "|l[abcikrstuvy]"
    + "|(?:mil|mobi|museum|m[acdghklmnopqrstuvwxyz])"
    + "|(?:name|net|n[acefgilopruz])"
    + "|(?:org|om)"
    + "|(?:pro|p[aefghklmnrstwy])"
    + "|qa"
    + "|dev"
    + "|r[eouw]"
    + "|(?:studio|s[abcdeghijklmnortuvyz])"
    + "|(?:tel|travel|t[cdfghjklmnoprtvwz])"
    + "|u[agkmsyz]"
    + "|v[aceginu]"
    + "|w[fs]"
    + "|xn--[\\w]*"
    + "|y[etu]"
    + "|рф"
    + "|укр"
    + "|z[amw]))"
    + "|(?:(?:25[0-5]|2[0-4]" // or ip address
    + "[0-9]|[0-1][0-9]{2}|[1-9][0-9]|[1-9])\\.(?:25[0-5]|2[0-4][0-9]"
    + "|[0-1][0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1]"
    + "[0-9]{2}|[1-9][0-9]|[1-9]|0)\\.(?:25[0-5]|2[0-4][0-9]|[0-1][0-9]{2}"
    + "|[1-9][0-9]|[0-9])))"
    + "(?:\\:\\d{1,5})?)" // plus option port number
    + "(\\/(?:(?:[a-zA-Z0-9\\;\\/\\?\\:\\@\\&\\=\\#\\~"  // plus option query params
    + "\\-\\.\\+\\!\\*\\'\\(\\)\\,\\_])|(?:\\%[a-fA-F0-9]{2}))*)?"
    + "(?:\\b|$)"

  export default {
    components: {
      MessageState
    },
    props: {
      time: String,
      message: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        text: '',
        preview: false,
        title: '',
        description: '',
        image: '',
      }
    },
    computed: {
      content() {
        return this.text
      }
    },
    mounted() {
      this.text = this.escapeHtml(this.message.content)
      this.text = this.createTextLinks(this.text)
      if (this.matchEmoji(this.text)) {
        this.text = this.replaceEmoji(this.text)
      }
    },
    updated() {
      if (this.message.data.linkMetadata) {
        this.loadMetadata()
      }
    },
    methods: {
      createTextLinks(text) {
        const regex = new RegExp(urlify)
        let s = text 
        let result = text
        for (;;) {
          let rez = s.match(regex)
          if (!rez)
            break
          let url = rez[0]
          if (!/^(f|ht)tps?:\/\//i.test(rez[0])) {
            url = "http://" + url
          }

          let pos = text.indexOf(rez[0])
          if (pos > 0 && text.charAt(pos - 1) == '@') {
            result;
            // TODO: emails href="mailto:"...
          } else {
            result = result.replace(rez[0], '<a href="' + url + '" target="_blank">' + rez[0] + '</a>')
            if (!this.preview) {
              if (this.message.data.linkMetadata) {
                this.loadMetadata()
              } else {
                this.$store.dispatch('getUrlMetadata', {
                  url:url, 
                  chatId: this.$store.state.currentChat.chatId, 
                  messageId: this.message.id
                })
              }
            }
          }
          s = s.substring(pos + rez[0].length)
        }
        return result
      },
      onPreviewClicked(e) {
        e.preventDefault()
        this.$store.dispatch('openLink', this.message.data.linkMetadata.url)
      },
      onClicked(e) {
        if (e.target.tagName != 'A')
          return
        e.preventDefault()
        this.$store.dispatch('openLink', e.target.href)  
      },
      loadMetadata() {
        let metadata = this.message.data.linkMetadata 
        this.title = metadata.title
        this.description = metadata.description

/* TODO       let image = this.message.data.linkImage
        if (image) {
          image = EventBus.getUserFolderPath() + image
          this.$store.dispatch('decodeFile', image).then(data => {
            this.image = 'data:image/*;base64,' + data
            this.preview = true
          })
        } else {
          this.preview = true
        }*/
      }
    }
  }
</script>

<style lang="scss">
  .preview-quote {
    white-space: normal;
    display: flex;
    cursor: pointer; 

    .preview-q {
      background-color: var(--v-accent-lighten1);
      width: 2px;
      flex: none;
      margin: 0px 8px 0px 0px;
    }
    .preview-title {
      color: var(--v-accent-lighten1);
    }
    .preview-content {
      line-height: 21px;
      max-height: 63px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .preview {
      min-width: 72px;
      max-width: 72px;
      height: 72px;
      background-repeat: no-repeat;
      background-position: center;
      background-position-x: center;
      background-size:cover;
      border-radius: inherit;
      margin: 5px;
    }
  }

  .bubble-box {
    padding: 4px 16px;
    box-sizing:border-box;
  }
  .selectable-text {
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
  }
  .selectable-text.invisible-space::after {
    content: '';
    display: inline-block;
    width: 0;
  }

  .theme--light .text-with-pad a {
    color:var(--v-accent-darken2);
  }
  .theme--dark .text-with-pad a {
    color:var(--v-accent-lighten3);
  }
</style>
